export default {
	paper: {
		margin: 0,
	},
};
